const Partners = (function () {

    const $ = require('jquery');
    const self = {};

    self.$partners = $('.ce-partners');

    self.init = function () {

        if (self.$partners.length > 0) {

            App.Globals.$window.on('load resize', function () {

                let $item = self.$partners.find('[data-height-equals-width]');
                let width = $item.width();

                $item.height(width);

            });

        }

    };

    return self;

}());

module.exports = Partners;
